export default "__VITE_ASSET__DIDUurrI__"